import { z } from "zod";
import { AccountType } from "../constants/domains/accounting/accounts";
import { ChartOfAccountsTemplateUploadSource } from "../constants/domains/accounting/chartOfAccountsTemplateAccount";

export const ChartOfAccountsTemplateUploadBodySchema = z.object({
    source: z.nativeEnum(ChartOfAccountsTemplateUploadSource),
});

export const ChartOfAccountsTemplateQuickbooksImportBodySchema = z.object({
    authCode: z.string().min(1),
    realmId: z.string().regex(/^\d+$/),
});

const ChartOfAccountsTemplateUploadRowSchema = z.object({
    id: z.string(),
    parentGroupId: z.string().nullable(),
    name: z.string(),
    codeText: z.string().nullable(),
    sourceType: z.string().nullable(),
    kickType: z.nativeEnum(AccountType).nullable(),
    sortOrder: z.number().int(),
});

export const ChartOfAccountsTemplateUploadResponseSchema = z.object({
    groups: z.array(ChartOfAccountsTemplateUploadRowSchema),
    accounts: z.array(ChartOfAccountsTemplateUploadRowSchema),
});

export type ChartOfAccountsTemplateUploadRow = z.infer<
    typeof ChartOfAccountsTemplateUploadRowSchema
>;

export type ChartOfAccountsTemplateUploadResponse = z.infer<
    typeof ChartOfAccountsTemplateUploadResponseSchema
>;
